import { render } from "./OpenApplicationDetails.vue?vue&type=template&id=d2741b74&scoped=true"
import script from "./OpenApplicationDetails.vue?vue&type=script&lang=js"
export * from "./OpenApplicationDetails.vue?vue&type=script&lang=js"

import "./OpenApplicationDetails.vue?vue&type=style&index=0&id=d2741b74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2741b74"]])

export default __exports__